import React from 'react';
import PropTypes from 'prop-types';

// SVGs
import { ReactComponent as QuestionMarkRoundIconSVG } from '../../../images/sprites/question-mark-round.svg';

export default class StatisticsBlockListItem extends React.Component {

    static propTypes = {
        highlightedText: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]).isRequired,
        label: PropTypes.string.isRequired,
        helpText: PropTypes.string
    };

    renderStatisticsHelp = () => {
        if (typeof this.props.helpText === 'undefined') {
            return;
        }

        return (
            <div className="statistics-blocklist__help">
                <QuestionMarkRoundIconSVG className="statistics-blocklist__help-icon" />
                <div className="statistics-blocklist__tooltip">
                    <span className="statistics-blocklist__tooltip-text">{this.props.helpText}</span>
                </div>
            </div>
        );
    };

    render() {
        const { highlightedText, label } = this.props;

        return (
            <li className="statistics-blocklist__item">
                <span className="statistics-blocklist__highlighted-text">{highlightedText === undefined || highlightedText === null ? '-' : highlightedText }</span>
                {label}
                {this.renderStatisticsHelp()}
            </li>
        );
    }
}
